import { GeoDsMeta } from './meta-data.model';

export class MailAndWebAddress extends GeoDsMeta {
  Type: string;
  MainAdress: boolean;
  Value: string;
  refAddress: string;

  constructor(data: MailAndWebAddress) {
    super();
    Object.assign(this, data);
  }
}
